"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrice = exports.getPrices = void 0;
const isomorphic_unfetch_1 = __importDefault(require("isomorphic-unfetch"));
const data_1 = require("./data");
function getPrices() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield (0, isomorphic_unfetch_1.default)("https://data.goblin.gold:7766/price");
        const data = yield response.json();
        return data.reduce((previous, current) => (Object.assign(Object.assign({}, previous), { [current.asset]: current.price })), {});
    });
}
exports.getPrices = getPrices;
function getPrice(token) {
    return __awaiter(this, void 0, void 0, function* () {
        const prices = yield getPrices();
        token = token === data_1.TOKENS.WSOL.symbol ? data_1.TOKENS.SOL.symbol : token;
        const match = prices[token];
        return match !== null && match !== void 0 ? match : 0;
    });
}
exports.getPrice = getPrice;
//# sourceMappingURL=prices.js.map